import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { NOME_MARCA } from '../../../../environments/environment';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ListaBase } from '../../../shared/crud/ListaBase';
import { FormatarData } from '../../../shared/formatarData';
import { RmpvOficinaMensalService } from './service/rmpv-oficina-mensal.service';
import { TotalizadorGrafico } from './totalizador-grafico';

declare var $: any;

@Component({
  selector: 'app-rmpv-oficina-mensal',
  templateUrl: './rmpv-oficina-mensal.component.html',
  styleUrls: ['./rmpv-oficina-mensal.component.css']
})
export class RmpvOficinaMensalComponent extends ListaBase implements OnInit {

  objTranslateAPI = {
    "Cliente": "rmpv.oficina.cliente",
    "Garantia": "rmpv.oficina.garantia",
    "Funilaria e Pintura": "rmpv.oficina.funilariaPintura",
    "Acessório": "rmpv.oficina.acessorio",
    "Retorno": "rmpv.oficina.retorno",
    "Recall": "rmpv.oficina.recall",
    "Cortesia": "rmpv.oficina.cortesia",
    "Revisão": "rmpv.oficina.revisao",
    "Seguro/Franquia": "rmpv.oficina.seguroFranquia",
    "Motos usadas": "rmpv.oficina.motosUsada",
    "Outras Internas": "rmpv.oficina.outraInterna",
    "Outras": "rmpv.oficina.outra",
    "PDI": "rmpv.oficina.pdi"
  };

  arrayTranslateChart = [{ categoria: "Cliente", chave: "rmpv.oficina.cliente" },
  { categoria: "Garantia", chave: "rmpv.oficina.garantia" },
  { categoria: "Funilaria e Pintura", chave: "rmpv.oficina.funilariaPintura" },
  { categoria: "Acessório", chave: "rmpv.oficina.acessorio" },
  { categoria: "Motos usados", chave: "rmpv.oficina.motosUsada" },
  { categoria: "Outras Internas", chave: "rmpv.oficina.outraInterna" },
  { categoria: "Cortesia", chave: "rmpv.oficina.cortesia"},
  { categoria: "Revisão", chave: "rmpv.oficina.revisao"},
  { categoria: "Seguro/Franquia", chave: "rmpv.oficina.seguroFranquia"},
  { categoria: "Outras", chave: "rmpv.oficina.outra" },
  { categoria: "Retorno", chave: "rmpv.oficina.retorno" },
  { categoria: "Recall", chave: "rmpv.oficina.recall" },
  { categoria: "PDI", chave: "rmpv.oficina.pdi" }
  ];

  carregando = false;
  categorias: string[] = [];
  totalGeral: any;
  marca = NOME_MARCA
  subscription;

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: { display: true },
  };

  public barChartLabels: string[] = [];
  public barChartLabelsCache: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = false;
  public barChartData: any[] = [];
  public barChartColors: any[] = [];

  @Input() modulo: any = 'oficina';
  state$: Observable<object>;
  grafico;
  valoresMarcasOriginal;
  parametrosFiltro: any;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query


  constructor(service: RmpvOficinaMensalService,
    private toast: ToastrService,
    router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toast, router);
    (this.service as RmpvOficinaMensalService).setNomeServico(this.modulo);
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['data_inicial'], params['data_final']);
      this.carregarFiltrosParametros();
    });

    this.getTranslateChart();
  }

  ngOnInit() {
    this.buscar();
    this.state$ = this.route.paramMap
      .pipe(map(() => window.history.state));
    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewChecked() {
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  setaValorData(dataInicial: Date, dataFinal: Date) {
    if (dataInicial === undefined || dataInicial.toString() === '') {
      const dt = new Date();
      const dataInicial = { 'year': dt.getFullYear(), 'month': dt.getMonth() + 1, 'day': 1 };
      const dataInicialFormata = new FormatarData(dataInicial.year, dataInicial.month, dataInicial.day, 0, 0, 0).getDataString();
      this.InicialData = dataInicialFormata;
    } else {
      const now = new Date(dataInicial);
      this.InicialData = now.getFullYear() + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + ("0" + (now.getUTCDate())).slice(-2);
    }

    if (dataFinal === undefined || dataFinal.toString() === '') {
      const FinalData = new Date();
      this.FinalData = { 'year': FinalData.getFullYear(), 'month': FinalData.getMonth() + 1, 'day': FinalData.getDate() };
    } else {
      const now = new Date(dataFinal);
      this.FinalData = now.getFullYear() + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + ("0" + (now.getUTCDate())).slice(-2);
    }
    this.filtros = { data_inicial: this.InicialData, data_final: this.FinalData };
  }

  protected getDados(res: any): any {
    if (res.meses.length === 0) {
      return res.meses;
    }


    res.meses.forEach(res => {

      res.marcas.total = this.conversaoLibraConverte.conversaoLibra(res.marcas.total, null, null);
      res.marcas[0].dados.forEach(res => {
        res.faturamento = this.conversaoLibraConverte.conversaoLibra(res.faturamento, null, null);
        res.horasTrabalhadas = this.conversaoLibraConverte.conversaoLibra(res.horasTrabalhadas, null, null);
        res.horasVendidas = this.conversaoLibraConverte.conversaoLibra(res.horasVendidas, null, null);
        res.valorMaoObraUnitario = this.conversaoLibraConverte.conversaoLibra(res.valorMaoObraUnitario, null, null);
      });
    });

    this.valoresMarcasOriginal = res;

    this.totalGeral = {};
    this.totalGeral.marcas = [];

    this.carregarTipos(res.meses[0].marcas[0]);
    this.calcularTotaisMensais(res);
    this.calcularTotalGeral();
    return res.meses;
  }

  private calcularTotalGeral() {
    let total = this.criarTotalizador(this.totalGeral.marcas[0], 'Total', 0);
    this.totalGeral.marcas.forEach(marca => {
      marca.faturamento = this.conversaoLibraConverte.conversaoLibra(marca.faturamento, null, null);
      marca.horasTrabalhadas = this.conversaoLibraConverte.conversaoLibra(marca.horasTrabalhadas, null, null);
      marca.horasVendidas = this.conversaoLibraConverte.conversaoLibra(marca.horasVendidas, null, null);
      marca.valorMaoObraUnitario = this.conversaoLibraConverte.conversaoLibra(marca.valorMaoObraUnitario, null, null);
      this.totalizarCategorias(marca);
      this.totalizarMarcas(marca, total);
    });

    this.carregarGraficos(this.totalGeral.marcas);
  }

  private calcularTotaisMensais(res: any) {
    res.meses.forEach(mes => {
      const totalMes = this.criarTotalizador(res.meses[0].marcas[0], 'Total', 0);
      this.totalizarPorMes(mes, totalMes);
    });
  }

  private totalizarPorMes(mes: any, totalMes: any) {
    mes.marcas.forEach(marca => {
      this.somarTotalGeralPorMarca(marca);
      this.totalizarCategorias(marca);
      this.totalizarMarcas(marca, totalMes);
    });

    this.totalizarCategorias(totalMes);
  }

  carregarGraficos(lista: any[]) {
    this.grafico = new TotalizadorGrafico();
    this.grafico.processar(lista);

    if (this.marca.includes("Triumph") || this.marca.includes("Harley")) {
    // if (this.marca === 'Triumph' || this.marca === "Harley") {
      if (this.translate.currentLang == 'br') {
        this.barChartLabels = this.grafico.getLabels();
      } else {
        this.barChartLabels = ["Client", "Guarantee", "Auto body and Paint", "Accessory", "PDI", "Return", "Recall", "Used motorcycles", "Other Interns", "Courtesy", "Other"];
      }
    } else if (this.marca.includes("Volvo") || this.marca.includes("Porsche") ||  this.marca.includes("Stuttgart") || this.marca.includes("GWM") || this.marca.includes("BYD") || this.marca.includes("NBS")) {
    // } else if (this.marca === 'Volvo') {
      if (this.translate.currentLang == 'br') {
        this.barChartLabels = this.grafico.getLabels();
      } else {
        this.barChartLabels = ["Client", "Guarantee", "Auto body and Paint", "Accessory", "PDI", "Return", "Recall", "Used cars", "Other Interns", "Courtesy", "Revision", "Insurance/Deductible", "Other"];
      }
    }

    this.barChartType = this.grafico.getTipo();
    this.barChartLegend = this.grafico.getLegenda();
    this.barChartColors = this.grafico.getColors();
    this.barChartData = this.grafico.getDados();
  }




  //************** Sublinha o label da marca no grafico quando o item fica desativado************* */
  toogleLabelJaguar() {
    $('.fontJaguar').toggleClass('active');
  }

  toogleLabelLandRover() {
    $('.fontLandRover').toggleClass('active');
  }

  /*************************************************************************************************/

  totalizarMarcas(marca: any, total: any) {
    marca.dados.forEach(element => {
      const index = total.dados.findIndex((item) => element.id === item.id);
      total.dados[index].faturamento += element.faturamento;
    });
  }

  criarTotalizador(objeto: any, descricao: string, id: number): any {
    const total: any = {};
    total.dados = [];

    objeto.dados.forEach(element => {
      const categoria: any = {};
      for (const chave in element) {
        if (element.hasOwnProperty(chave)) {
          categoria[chave] = element[chave];
        }
      }
      categoria.faturamento = 0;
      total.dados.push(categoria);
    });

    total.id = id;
    total.marca = descricao;
    return total;
  }

  somarTotalGeralPorMarca(marca: any) {
    let item: any;

    const index = this.totalGeral.marcas.findIndex((p) => marca.id === p.id);

    if (index < 0) {
      item = this.criarTotalizador(marca, marca.marca, marca.id);
      this.totalGeral.marcas.push(item);
    } else {
      item = this.totalGeral.marcas[index];
    }

    item.dados.forEach(element => {
      const posicao = marca.dados.findIndex((c) => c.id === element.id);
      const fat = marca.dados[posicao].faturamento;
      element.faturamento += fat;
    });
  }

  carregarTipos(marca: any): any {
    this.categorias = [];
    marca.dados.forEach(element => {
      this.categorias.push(element.nome);
    });
  }

  totalizarCategorias(marca: any) {
    let total = 0;
    let internas = 0;

    marca.dados.forEach(categoria => {
      total += categoria.faturamento;
      internas += categoria.interna ? categoria.faturamento : 0;
    });
    marca.total = total;
    marca.internas = internas;
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  public definirFiltragem() {
    $('#rmpv-oficina-mensal-filtro').modal();
  }

  voltar() {
    this.router.navigateByUrl(this.obterUrlComFiltros());
  }

  obterUrlComFiltros(): string {
    let url = '';
    for (const filtro in this.filtros) {
      if (this.filtros.hasOwnProperty(filtro)) {
        url += url ? '&' + filtro + '=' + this.filtros[filtro] : '?' + filtro + '=' + this.filtros[filtro];
      }
    }
    return 'rmpv/oficina' + url;
  }

  getTranslate(value) {
    if (value == 'Motos usadas') {
      return value = this.translate.currentLang == 'br' ? 'Motos usadas' : 'Used motorcycles';
    } else if (value == 'Carros usados') {
      return value = this.translate.currentLang == 'br' ? 'Carros usados' : 'Used cars';
    }
    return this.objTranslateAPI[value];
  }

  getTranslateChart() {
    if (!this.dados) {
      return;
    }

    this.translate.onLangChange
      .subscribe((event: TranslationChangeEvent) => {
        let labelsTranslateChart;
        if (!this.barChartLabelsCache.length) {
          this.barChartLabelsCache = Array.from(this.barChartLabels);
        }

        this.translate
          .stream(this.arrayTranslateChart.map(item => item.chave))
          .subscribe(value => {

            labelsTranslateChart = [];
            this.barChartLabelsCache.forEach(element => {

              this.arrayTranslateChart.forEach(item => {
                if (element === item.categoria) {
                  labelsTranslateChart.push(value[item.chave]);
                }
              });

            });
            this.barChartLabels = Array.from(labelsTranslateChart);

          }, error => console.log(error));
      });
  }

}
